export function humanReadableErrorMessage(error) {
  switch (error) {
    case 'API permission has been removed':
      return 'Your Facebook API permission has been removed. Please reconnect Facebook in Clearbit X.';
    case 'access token is missing':
      return 'Your Facebook account is disconnected. Please reconnect Facebook in Clearbit X.';
    case 'cannot be accessed':
      return 'Your Facebook Custom Audience cannot be accessed.';
    case "doesn't have permission to create audience":
      return "Your Facebook account doesn't have permission to create Facebook Custom Audience.";
    case "doesn't have write permission to create audience":
      return "Your Facebook account doesn't have write permission to create Facebook Custom Audience under this ad account.";
    case 'failed security checkpoint':
      return 'Your Facebook account has failed a security checkpoint. Please sign in to Facebook and reconnect Facebook in Clearbit X.';
    case 'is not a business account':
      return 'You need a Facebook Business Account to create Facebook Custom Audiences.';
    case 'is not present':
      return 'Is required.';
    case 'password has changed or Facebook has changed the session for security reasons':
      return 'Your Facebook password has changed. Please update your password and reconnect Facebook in Clearbit X.';
    case 'session has expired':
      return 'Your Facebook session has expired. Please reconnect Facebook in Clearbit X.';
    case 'terms are not accepted':
      return 'Please accept the Facebook Custom Audience Terms.';
    default:
      return error;
  }
}
